module.exports = __webpack_public_path__ + "img/20200613_141828.66d3a519.jpg";